/**
 * Build an absolute, shareable URL for a flight from its id and the app origin.
 *
 * The origin is passed in (rather than read from `window.location.origin`
 * directly) so the function stays pure and unit-testable outside a browser.
 */
export function getFlightShareUrl(flightId: number, origin: string, view?: "3d"): string {
  return `${origin}/flight/${flightId}${view === "3d" ? "?view=3d" : ""}`;
}

export function getGliderDisplayName(
  gliderId: string | undefined,
  initialName: string | undefined,
  gliders: Array<{ id: string; name: string }>,
): string | undefined {
  if (!gliderId) return undefined;
  return gliders.find(glider => glider.id === gliderId)?.name || initialName || undefined;
}
